import { axiosHelper } from '@setvi/shared/services';
import { AxiosMethods, SalesEnablementApi } from '@setvi/shared/enums';
import { ProductMetadataParams } from 'Services/Mutations/Sales-Enablement/types';

export enum SalesEnablementQueryKey {
  GET_CONTENT = 'GET_SALES_ENABLEMENT_CONTENT',
  GET_ITEMS = 'GET_SALES_ENABLEMENT_ITEMS',
  GET_METADATA = 'GET_METADATA',
  GET_SINGLE_CONTENT_BY_PROMPT_NAME = 'GET_SINGLE_CONTENT_BY_PROMPT_NAME',
  ASK_AI_PROMPTS = 'GET_ASK_AI_PROMPTS'
}

export const getSalesEnablementContentQuery = (
  productId: string,
  categoryId?: string
) => ({
  queryKey: [SalesEnablementQueryKey.GET_CONTENT],
  queryFn: () =>
    axiosHelper({
      endpoint: SalesEnablementApi.GetSalesEnablementContent.replace(
        ':productId',
        productId
      ),
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_INTELLIGENCE_API,
      params: { ...(categoryId ? { categoryId } : {}) }
    }),
  cacheTime: 0
});

export const getSalesEnablementItemsQuery = (categoryId: string) => ({
  queryKey: [SalesEnablementQueryKey.GET_ITEMS],
  queryFn: () =>
    axiosHelper({
      endpoint: SalesEnablementApi.GetSalesEnablementItems.replace(
        ':categoryId',
        encodeURIComponent(categoryId)
      ),
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_INTELLIGENCE_API
    }),
  cacheTime: 0
});

export const getProductMetadataQuery = (params: ProductMetadataParams) => ({
  queryKey: [SalesEnablementQueryKey.GET_METADATA, params],
  queryFn: () =>
    axiosHelper({
      endpoint: SalesEnablementApi.ProductMetadata,
      method: AxiosMethods.GET,
      baseURL: process.env.INTELLIGENCE_EXPERIMENTAL_API,
      headers: {
        Authorization: 'ApiKey ab8e4a0d-b789-41d5-843d-8b0b675668f8'
      },
      params
    }),
  cacheTime: 0
});

export const getSingleSalesKitByName = (productId: string, name?: string) => ({
  queryKey: [
    SalesEnablementQueryKey.GET_SINGLE_CONTENT_BY_PROMPT_NAME,
    productId
  ],
  queryFn: () =>
    axiosHelper({
      endpoint:
        SalesEnablementApi.GetSalesEnablementContentByPromptName.replace(
          ':productId',
          encodeURIComponent(productId)
        ),
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_INTELLIGENCE_API,
      params: { ...(name ? { name } : {}) }
    }),
  cacheTime: 0
});

export const getAskAiPrompts = () => ({
  queryKey: [SalesEnablementQueryKey.ASK_AI_PROMPTS],
  queryFn: () =>
    axiosHelper({
      endpoint: '/45bc97f5f7a33b8029b3',
      method: AxiosMethods.GET,
      baseURL: 'https://api.npoint.io'
    })
});
